<template>
  <div class="login row justify-content-center">
    <!-- NOTE: Left Login Choose view -->
    <div class="col-6 left-login">
      <div class="row justify-content-between">
        <div class="col-2">
          <button
            type="button"
            class="btn"
            @click="openHelpPage"
          >
            <i class="fas fa-question-circle fa-lg" />
          </button>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn btn-borderless-primary btn-lg"
            @click="changeLang"
          >
            <i class="fas fa-language fa-lg" />
            {{ $t('General.ChangeLang') }}
          </button>
        </div>
      </div>

      <div class="row">
        <img
          :src="require('../../assets/abeja_logo.png')"
          class="rounded mx-auto d-block abeja-icon"
        >
      </div>

      <div class="row">
        <div class="col text-center">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="MicrsoftAuthLogin"
          >
            <i class="fab fa-microsoft" />
            {{ $t('Login.Button.MicrsoftLogin') }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="googleAuthLogin"
          >
            <i class="fab fa-google" />
            {{ $t('Login.Button.GoogleLogin') }}
          </button>
        </div>
      </div>

      <div class="row link-container">
        <div>
          <a
            :href="`https://agently.abeja.io/${$route.params.lang}/terms-of-use`"
            target="_blank"
          >
            {{ $t("LOGIN.TermsOfUse") }}
          </a>
        </div>
        <div>
          <a
            :href="`https://agently.abeja.io/${$route.params.lang}/privacy-policy`"
            target="_blank"
          >
            {{ $t("LOGIN.PrivacyPolicy") }}
          </a>
        </div>
      </div>
    </div>

    <!-- NOTE: Right System Information view -->
    <div class="col-6 right-info">
      <div
        v-if="informationHTML"
        v-html="informationHTML"
      />
      <div v-else>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-8 information-container">
              <span class="announce-title">{{ $t("LOGIN.NoInformation") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import firebaseHelper from '@/helper/firebaseHelper'
import { INTERCOM_URL } from '@/config/constants'

export default {
  title: 'Login',
  data: () => ({
    lang: 'ja'
  }),
  computed: {
    ...mapState('auth', [
      'isNewUser'
    ]),
    informationHTML() {
      return null
    }
  },
  mounted() {
    this.setLang()
  },
  watch: {
    '$route': 'setLang'
  },
  methods: {
    ...mapActions([
      'setLanguage',
      'setLoadingState',
      'unsetLoadingState'
    ]),
    ...mapActions('auth', [
      'setLoginByGoogle',
      'setLoginByMicrosoft',
      'setGoogleUserAuth',
      'setMicrosoftUserAuth',
      'setCurrentData',
      'connectApi4Gsuite',
      'setApiUserAuth',
      // 'getMicrosoftUserInfo'
    ]),
    setLang () {
      if (!this?.$route) return null
      const l = this.$route.params.lang
      this.setLanguage(l)
      this.lang = l
    },
    changeLang () {
      const nextLang = this.lang === 'ja' ? 'en' : 'ja'
      this.$router.push({
        name: 'Login',
        params: { lang: nextLang }
      })
    },
    openHelpPage () {
      open(INTERCOM_URL, '_blank')
    },
    MicrsoftAuthLogin () {
      this.setLoadingState('login')
      firebaseHelper.signInMicrosoft().then( async (res) => {
        console.log('login data', res)
        await this.setLoginByMicrosoft(res)
        return res?.additionalUserInfo.isNewUser
      }).then( async (isNewUser) => {
        // NOTE: ユーザの画像URLを可能ならば取得
        // this.getMicrosoftUserInfo()
        if (isNewUser) {
          await this.setMicrosoftUserAuth('First User login')
          this.$router.push({
            name: 'Setup'
          })
        } else {
          this.setApiUserAuth().then(() => {
            this.$router.push({
              name: 'SmartScheduling'
            })
          }).catch( async (err) => {
            // NOTE: need setting for api
            await this.setMicrosoftUserAuth('First User login')
            console.log('need setting for api')
            this.$router.push({
              name: 'Setup'
            })
          })
        }
      }).catch((err) => {
        return Promise.reject(err)
      }).finally(() => {
        this.unsetLoadingState('login')
      })
      return true
    },
    googleAuthLogin () {
      this.setLoadingState('login')
      firebaseHelper.signInGoogle().then( async (res) => {
        console.log('login data', res)
        await this.setLoginByGoogle(res)
        return res?.additionalUserInfo.isNewUser
      }).then( async (isNewUser) => {
        console.log('setLoginData')
        if (isNewUser) {
          await this.setGoogleUserAuth('First User login')
          this.$router.push({
            name: 'Setup'
          })
        } else {
          this.setApiUserAuth().then(() => {
            this.$router.push({
              name: 'SmartScheduling'
            })
          }).catch( async (err) => {
            // NOTE: need setting for api
            await this.setGoogleUserAuth('First User login')
            console.log('need setting for api')
            this.$router.push({
              name: 'Setup'
            })
          })
        }
      }).catch((err) => {
        return Promise.reject(err)
      }).finally(() => {
        this.unsetLoadingState('login')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  max-width: 100vw;
  height: 100%;

  .abeja-icon {
    max-width: 160px;
    margin: 80px 0;
  }

  .link-container {
    display: block;
    text-align: center;
    margin: 80px 0;
  }
}
.right-info {
  background-image: url("../../assets/login_bg_image.png");
  background-size: cover;
  background-position: center center;
  height: 100%;
  width: 100%;

  .information-container {
    display: block;
    font-size: 1.4rem;
    font-weight: 700;
    padding: 16px 0;
    text-align: center;
    width: 30vw;
    background-color: #fff;
    border-radius: 16px;
    padding: 32px;
    margin-top: 10vh;
  }
}
</style>
